import React from 'react'
import PropTypes from 'prop-types'
import ModalFooter from 'components/ModalFooter'
import ModalHeader from 'components/ModalHeader'
import ModalIntro from 'components/ModalIntro'
import { StyledModal } from './component.styles'

const InformFamilyModal = ({
  handleClose,
  handleNextButtonClick,
  hasApiError,
  modals,
}) => {
  const { helpCopy, nextLabel } = modals?.[0] || {}

  return (
    <StyledModal
      dataTestId="inform-family-modal"
      isModalOpen={true}
      modalClose={() => handleClose}
    >
      <ModalHeader handleClose={handleClose} showBackButton={false} />
      <ModalIntro modalData={modals[0]} />
      <ModalFooter
        handleNextButtonClick={handleNextButtonClick}
        hasApiError={hasApiError}
        helpCopy={helpCopy}
        isValid={true}
        modalName="inform-family"
        nextButtonText={nextLabel}
        showCancelButton={false}
      />
    </StyledModal>
  )
}

InformFamilyModal.propTypes = {
  flowLabel: PropTypes.string,
  handleClose: PropTypes.func,
  handleNextButtonClick: PropTypes.func,
  hasApiError: PropTypes.bool,
  modals: PropTypes.array,
}

export default InformFamilyModal
